import {API_URL} from 'api/constants'

export const LIBRARY_CATEGORIES = `${API_URL}/v2/categories`
export const LIBRARY_CATEGORIES_V1 = `${API_URL}/v1/categories`
export const V1_CATEGORY_BY_ID = (id) => `${API_URL}/v1/categories/${id}`
export const CATEGORY_ALL_OUTLETS = `${API_URL}/v1/categories/create_all_outlet`
export const ASSIGN_TO_ITEM = (id) => `${API_URL}/v1/categories/${id}/move_items`
export const V1_CATEGORIES_WITH_UNCATEGORIZED = `${API_URL}/v1/categories/with_uncategorized`



// WEBPACK FOOTER //
// ./app/api/categories/constants.js